import { BehaviorSubject, Observable } from 'rxjs';

export class LoadingService {

  private isLoadingRequestsStream$ = new BehaviorSubject<boolean>(false);

  setLoader(flag: boolean) {
    this.isLoadingRequestsStream$.next(flag);
  }

  getLoadingStream(): Observable<boolean> {
    return this.isLoadingRequestsStream$.asObservable();
  }
}
